import styled, { css } from 'styled-components';
import { IconContainer } from '../../../../icon';
import Typography from '../../../../typography';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
import { NAVIGATION_VIEWPORT_BREAKPOINTS } from '../../../constants';
export const navigationSubItemsToggleContainerStyles = ({ theme, $anyIsActive, $isActive, $isHighlighted, }) => css `
	appearance: none;
	position: relative;
	display: ${!$anyIsActive ? 'flex' : 'none'};
	align-self: stretch;
	justify-content: ${$isActive ? 'flex-start' : 'space-between'};
	align-items: center;
	gap: ${pxToRem(theme.spacing['50'])};
	padding: ${pxToRem(theme.spacing['200'])} ${pxToRem(theme.spacing['100'])};
	border: none;
	border-radius: unset;
	color: ${theme.colors.base.textMainNavigation};
	background-color: ${theme.colors.blanc.bgButton};

	${$isActive &&
    css `
		display: flex;
	`}

	&:hover {
		color: ${theme.colors.highlight.textInteractiveOnLight};
	}

	&:focus {
		color: unset;
	}

	&:focus-visible {
		outline: ${theme.borderWidth.m}px solid ${theme.colors.highlight.borderFocus};
		outline-offset: -${theme.borderWidth.m}px;
	}

	${IconContainer} {
		flex: none;
		color: ${theme.colors.highlight.iconInteractive};
	}

	@media (max-width: ${pxToRem(Number(NAVIGATION_VIEWPORT_BREAKPOINTS.lg) - 1)}) {
		border-radius: ${pxToRem(theme.borderRadius.xs)};

		&:hover {
			color: ${theme.colors.highlight.textHover};
			background-color: ${theme.colors.extralight.bgNavigationItemHover};
		}

		&:active {
			background-color: ${theme.colors.base.bgNavigationItemActive};
			color: ${theme.colors.blanc.textInverse};

			${IconContainer} {
				color: ${theme.colors.blanc.iconInteractiveInverse};
			}
		}
	}

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.lg)}) {
		display: flex;

		${($isActive || $isHighlighted) &&
    css `
			&& {
				&::after {
					content: '';
					position: absolute;
					top: unset;
					right: ${pxToRem(theme.spacing['100'])};
					bottom: 0;
					left: ${pxToRem(theme.spacing['100'])};
					height: ${theme.borderWidth.m}px;
				}
			}
		`}

		${$isHighlighted &&
    css `
			&::after {
				background-color: ${theme.colors.base.bgNavigationItemActive};
			}
		`}

			${$isActive &&
    css `
			&,
			&:hover,
			&:focus {
				color: ${theme.colors.highlight.textInteractiveOnLight};
			}

			&::after {
				background-color: ${theme.colors.highlight.textInteractiveOnLight};
			}
		`}

		${IconContainer} {
			display: none;
		}
	}
`;
export const NavigationSubItemsToggleContainer = styled(Typography) `
	${navigationSubItemsToggleContainerStyles}
`;
export const navigationSubItemsToggleContentStyles = () => css `
	display: flex;
	align-items: center;
	text-align: left;
	overflow: hidden;
`;
export const NavigationSubItemsToggleContent = styled.span `
	${navigationSubItemsToggleContentStyles}
`;
